import axios from "axios";
import { encryptStorage } from "../../../constants/EncryptStorage";
import { BASEURL } from "../../../constants/const";

export function ApiFinance() {
  const userToken = encryptStorage.getItem("token");

  const authAxios = axios.create({
    baseURL: BASEURL,
    headers: {
      Authorization: `Bearer ${userToken}`,
    },
  });

  const url = BASEURL + "finance/";
  return {

    //EXPENSE HEADS
    GetExpenseHeadsListFromFinanceSoftware: () =>
      authAxios.get(url + "GetExpenseHeadsListFromFinanceSoftware"),
    GetExpenseHeadsList: () => authAxios.get(url + "GetExpenseHeadsList"),
    GetFinanceExpenseHeadsList: () => authAxios.get(url + "GetFinanceExpenseHeadsList"),
    AddFinanceFrequentUsedExpenseHead: (record) =>
      authAxios.post(url + "AddFinanceFrequentUsedExpenseHead", record),
    UpdateFinanceExpenseHead: (record) =>
      authAxios.post(url + "UpdateFinanceExpenseHead/", record),
    DeleteExpenseHead: (id) => authAxios.delete(url + "DeleteExpenseHead/" + id),

    //INFAQ HEADS
    GetFinanceInfaqHeadsListFromFinanceSoftware: () =>
      authAxios.get(url + "GetFinanceInfaqHeadsListFromFinanceSoftware"),
    GetInfaqHeadsList: () => authAxios.get(url + "GetInfaqHeadsList"),
    GetFinanceInfaqHeadList: () =>
      authAxios.get(url + "GetFinanceInfaqHeadList"),
    AddFinanceInfaqHead: (record) =>
      authAxios.post(url + "AddFinanceInfaqHead", record),
    UpdateFinanceInfaqHead: (record) =>
      authAxios.post(url + "UpdateFinanceInfaqHead/", record),
    DeleteInfaqHead: (id) => authAxios.delete(url + "DeleteInfaqHead/" + id),


    //FINANCE CATEGORIES
    GetFinanceCategoriesList: () => authAxios.get(url + "GetFinanceCategories"),
    AddFinanceCategory: (record) =>
      authAxios.post(url + "AddFinanceCategory", record),
    UpdateFinanceCategory: (id, record) =>
      authAxios.put(url + "UpdateFinanceCategory/" + id, record),
    DeleteFinanceCategory: (id) =>
      authAxios.delete(url + "DeleteFinanceCategory/" + id),

    //FINANCE ACCOUNT CATEGORY TYPES
    GetFinanceSubCategoryTypes: () =>
      authAxios.get(url + "GetFinanceSubCategoryTypes"),
    AddFinanceSubCategoryType: (record) =>
      authAxios.post(url + "AddFinanceSubCategoryType", record),
    UpdateFinanceSubCategoryType: (id, record) =>
      authAxios.put(url + "UpdateFinanceSubCategoryType/" + id, record),
    DeleteFinanceSubCategoryType: (id) =>
      authAxios.delete(url + "DeleteFinanceSubCategoryType/" + id),

    //FINANCE ACCOUNT CATEGORY
    GetFinanceSubCategories: (unitId) => {
      const parsedUnitId = parseInt(unitId);
      const uId = (!isNaN(parsedUnitId) && parsedUnitId > 0) ? parsedUnitId : 0;
      return authAxios.get(url + "GetFinanceSubCategories/" + uId);
    },
    GetFinanceSubCategoriesForUnit: (unitId, scope) =>
      authAxios.get(url + "GetFinanceSubCategoriesForUnit/" + unitId, { params: { scope } }),
    GetFinanceSubCategoriesList: () =>
      authAxios.get(url + "GetFinanceSubCategoriesList"),
    GetFinanceSubCategoriesListByType: (type) =>
      authAxios.get(url + "GetFinanceSubCategoriesListByType/" + type),
    AddFinanceSubCategory: (record) =>
      authAxios.post(url + "AddFinanceSubCategory", record),
    UpdateFinanceSubCategory: (id, record) =>
      authAxios.put(url + "UpdateFinanceSubCategory/" + id, record),
    UpdateFinanceSubCategories: (id, record) =>
      authAxios.put(url + "UpdateFinanceSubCategories/" + id, record),
    DeleteFinanceSubCategory: (id) =>
      authAxios.delete(url + "DeleteFinanceSubCategory/" + id),

    //FINANCE DIMENSIONS
    GetFinanceDimensionsListFromFinanceSoftware: () =>
      authAxios.get(url + "GetFinanceDimensionsListFromFinanceSoftware"),
    UpdateFinanceDimensions2: (id, record) =>
      authAxios.put(url + "UpdateFinanceDimensions2/" + id, record),
    GetFinanceSubCategoryDimensionsById: (id, unitId) => {
      const parsedUnitId = parseInt(unitId || encryptStorage.getItem("loggedInUnitId"));
      const uId = (!isNaN(parsedUnitId) && parsedUnitId > 0) ? parsedUnitId : 0;
      return authAxios.get(url + "GetFinanceSubCategoryDimensionsById/" + id + "/" + uId);
    },

    //FINANCE ACCOUNTS
    UpdateFinanceAccounts: (id, record) =>
      authAxios.put(url + "UpdateFinanceAccounts/" + id, record),
    GetFinanceSubCategoryAccountsById: (id, unitId) => {
      const parsedUnitId = parseInt(unitId || encryptStorage.getItem("loggedInUnitId"));
      const uId = (!isNaN(parsedUnitId) && parsedUnitId > 0) ? parsedUnitId : 0;
      return authAxios.get(url + "GetFinanceSubCategoryAccountsById/" + id + "/" + uId);
    },
    UpdateUnitFinanceAccounts: (id, unitId, record) =>
      authAxios.put(url + "UpdateUnitFinanceAccounts/" + id + "/" + unitId, record),
    UpdateUnitFinanceDimensions2: (id, unitId, record) =>
      authAxios.put(url + "UpdateUnitFinanceDimensions2/" + id + "/" + unitId, record),
    GetExpenseAmountLimit: () =>
      authAxios.get(url + "GetExpenseAmountLimit"),
  };
}
